import { apiClient } from './client';

/**
 * Get course enrollments
 * @param {string} courseId
 * @param {{ page?, limit?, search?, status?, sortBy?, sortOrder? }} params
 */
export async function getCourseEnrollments(courseId, params = {}) {
  const { data } = await apiClient.get(`/courses/${courseId}/enrollments`, { params });
  return data;
}

/**
 * Get enrollment details
 * @param {string} courseId
 * @param {string} enrollmentId
 */
export async function getEnrollment(courseId, enrollmentId) {
  const { data } = await apiClient.get(`/enrollments/${enrollmentId}`);
  return data;
}

/**
 * Give a person a course by phone number (+ name). The backend finds the account by phone or
 * creates it, and enrolls it at once — signing in with that number (phone + OTP) lands in the
 * course. Replaces the old manual enroll, which needed a registered student id.
 * @param {{ phone: string, firstName: string, lastName?: string, courseId: string, pricingTierId?: string, note?: string }} body
 * @returns {Promise<{ userId: string, enrollmentId: string, accountCreated: boolean, alreadyEnrolled: boolean }>}
 */
export async function grantCourseAccess(body) {
  const { data } = await apiClient.post('/enrollments/grant', body);
  return data;
}

/**
 * Get course students with progress.
 *
 * The backend's ListStudentsQueryDto is `forbidNonWhitelisted: true` and
 * only accepts limit/offset/status/search — no `page` and no sort params
 * under any name. Only those four are forwarded here (even if a caller
 * passes something else) so this route can never regress into sending a
 * property the backend 400s on.
 *
 * @param {string} courseId
 * @param {{ limit?: number, offset?: number, search?: string, status?: string }} params
 */
export async function getCourseStudents(courseId, params = {}) {
  const { limit, offset, search, status } = params;
  const whitelisted = { limit, offset, search, status };
  const { data } = await apiClient.get(`/teacher/courses/${courseId}/students`, { params: whitelisted });
  return data;
}

/**
 * Get individual student progress
 * @param {string} courseId
 * @param {string} studentId
 */
export async function getStudentProgress(courseId, studentId) {
  const { data } = await apiClient.get(`/teacher/courses/${courseId}/students/${studentId}`);
  return data;
}
